import * as d3 from 'd3';

type Arguments = {
  colorRange: string[];
  domain?: string[];
};

const colorCache = new Map<string, d3.ScaleOrdinal<string, unknown>>();

export const createColors = ({ colorRange, domain }: Arguments) => {
  const cacheKey = JSON.stringify({ colorRange, domain });

  if (colorCache.has(cacheKey)) {
    return { colors: colorCache.get(cacheKey)! };
  }

  const colors = d3.scaleOrdinal().range(colorRange);
  if (domain) {
    colors.domain(domain);
  }

  colorCache.set(cacheKey, colors);

  return { colors };
};
